import { SettingsCustomFormFieldData } from '../../../models/settings/settings-custom-form-field-data.class';
import { FieldDataInterface } from '../../../models/settings/settings-custom-form-field-data.model';

export class SettingsArtworkLinkSelectorV1Field extends SettingsCustomFormFieldData {

    public dynamic_field: Array<string> = []; // (field ids associated ),  
    public tag_filter : Array< number> = []; // (tag ids)> ,  
    public status_filter : number | null = null; // ( status id)
    // constructor(type:string, field?:FieldDataInterface) {
    //   super(type, field);
    // }

    public serialize(): FieldDataInterface {
        return this._serialize({ 
            dynamic_field: this.dynamic_field,
            tag_filter: this.tag_filter,
            status_filter: this.status_filter
         });
    }

    public deserialize(field: FieldDataInterface): SettingsArtworkLinkSelectorV1Field {
        const self = new SettingsArtworkLinkSelectorV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
        // Deserialize other properties using class's logic
        self.dynamic_field = field.options.dynamic_field,
        self.tag_filter = field.options.tag_filter,
        self.status_filter = field.options.status_filter
        return self;
    }

    public update(updateData: Partial<SettingsArtworkLinkSelectorV1Field>) : SettingsArtworkLinkSelectorV1Field {
        // Create a new instance with the initial data
        const self = new SettingsArtworkLinkSelectorV1Field(
            this.type,
            this.position,
            this.id,
            this.label,
            this.mandatory,
            this.active,
        );

        self.dynamic_field = this.dynamic_field,
        self.tag_filter = this.tag_filter,
        self.status_filter = this.status_filter

        // Apply any updates provided in updateData
        if (updateData) {
            Object.assign(self, updateData);
            // mark the field as changed    
            self.changed = true;
        }
        
        return self;
    }
}
